import { render, staticRenderFns } from "./hospitalIntroduction.vue?vue&type=template&id=47347e73&scoped=true"
import script from "./hospitalIntroduction.vue?vue&type=script&lang=js"
export * from "./hospitalIntroduction.vue?vue&type=script&lang=js"
import style0 from "./hospitalIntroduction.vue?vue&type=style&index=0&id=47347e73&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47347e73",
  null
  
)

export default component.exports